module.exports = __webpack_public_path__ + "static/media/angle0.2646d6da.svg";